define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/image/_base",
	"csi/xml"
], function(array, declare, Controller, image, xml) {

	return declare(Controller, {
		// String: new key for moved image
		_keyNew: null,

		// Number: direction to move key
		_nOffset: -1,

		toWriter: function() {
			// summary: swap keys for current and next images
			var a = this.m_action;
			var key = this.widget.getCurrentImageKey();
			var obj = a.getImageValue(this.getNode());
			var keys = image.getNumberedKeys(obj);
			var n = array.indexOf(keys, key) + this._nOffset;
			if (n >= 0) {
				var cn = this.m_writer.changeNode(this.m_urlNode);
				var map = {};

				this._keyNew = keys[n];

				map[this._keyNew] = obj[key];
				map[key] = obj[this._keyNew];

				if (xml.nodeAttributeHasExpression(this.getNode(), a.idAttr)) {
					cn.disableAttributeExp(a.idAttr);
				}

				cn.changeAttributeKeys(a.idAttr, xml.ATTR_REFMAP, map, true);
			}
		},

		postProcessSuccess: function() {
			// summary: refresh view
			this.widget.moveImage(this._keyNew, this._nOffset === -1);
		}
	});
});